export default "__VITE_ASSET__715a80b2__"